import React from 'react'
import Text from '../Text/Text'
import Link from '../Links/Link'

const PLAN_MAX={free: 5,plus: 150,premium: Infinity}

export default function Credits({credits,className,plan,...props}) {
    const max=PLAN_MAX[plan==='premium'?'premium':plan==='plus'?'plus':'free']
    const pct=max===Infinity? 100:Math.min(100,((credits||0)/max)*100)

    // Color: green ≥50%, yellow 20-49%, red <20%
    const barColor=pct>=50?'bg-success':pct>=20?'bg-warning':'bg-danger'
    const textColor=pct>=50?'text-success-700':pct>=20?'text-warning-700':'text-danger-700'
    const bgColor=pct>=50?'bg-success-100':pct>=20?'bg-warning-100':'bg-danger-100'

    const daysLeft=new Date(new Date().getFullYear(),new Date().getMonth()+1,0).getDate()-new Date().getDate()

    return (
        <div className={`flex flex-col gap-1.5 w-full lg:w-64 ${className||''}`} role="status" aria-label={`${credits} credits remaining`}>
            {/* Bar */}
            <div className="relative w-full h-2.5 rounded-full bg-gray-200 overflow-hidden" aria-hidden="true">
                <div
                    className={`absolute left-0 top-0 h-full rounded-full transition-all duration-500 ${barColor}`}
                    style={{width: `${pct}%`}}
                />
            </div>
            {/* Label */}
            <div className={`flex items-center justify-between px-2 py-1 rounded-md text-xs font-semibold ${bgColor} ${textColor}`}>
                <span>{max===Infinity?'Unlimited':`${credits||0} / ${max} credits`}</span>
                {plan!=='premium'&&<Link className='!text-xs underline opacity-70 hover:opacity-100' to='/pricing'>Upgrade</Link>}
            </div>
            {plan==='plus'&&credits<max&&(
                <Text className='text-xs text-gray-400 text-center'>Resets in {daysLeft} day{daysLeft!==1?'s':''}</Text>
            )}
        </div>
    )
}
